var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',_vm._g(_vm._b({},'Popup',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"authenPopupBox"},[_c('div',{staticClass:"authenPopupText"},[_vm._v("您还没绑定企业，请先绑定")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }